import {
  FormControl,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
} from "@mui/material";
import MDBox from "components/MDBox";
import { approveStatusList } from "../../../constants/transaction.constants";
import ClearIcon from "@mui/icons-material/Clear";

const MenuProps = {
  PaperProps: {
    style: {
      width: 250,
    },
  },
};

const WithdrawalFilters = (props) => {
  const {
    handleApproveStatus,
    isApprovedFilterValue,
    setIsApproveFilterValue,
  } = props;
  return (
    <MDBox pt={3}>
      <Grid container spacing={4} p={3}>
        <Grid item xs={12} md={6} lg={4} xl={3}>
          <FormControl sx={{ minHeight: 48 }} fullWidth>
            <InputLabel
              style={{ backgroundColor: "white", padding: "0px 2px" }}
              id="admin-approved-label">
              Admin Approved
            </InputLabel>
            <Select
              labelId="admin-approved-label"
              id="admin-approved-status"
              value={isApprovedFilterValue}
              onChange={handleApproveStatus}
              sx={{ minHeight: 48 }}
              input={<OutlinedInput label="User Status" />}
              MenuProps={MenuProps}
              endAdornment={
                <IconButton
                  sx={{
                    visibility: isApprovedFilterValue ? "visible" : "hidden",
                    position: "absolute",
                    right: "25px",
                    marginRight: "0",
                  }}
                  style={{
                    backgroundColor: "white",
                  }}
                  onClick={() => {
                    setIsApproveFilterValue("");
                  }}
                  size="small">
                  <ClearIcon />
                </IconButton>
              }>
              {approveStatusList.map((status) => (
                <MenuItem value={status.value} key={status.value}>
                  {status.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
      </Grid>
    </MDBox>
  );
};

export default WithdrawalFilters;
